import * as React from 'react';
import styled from 'styled-components';

import { grayLighter, grayMain } from 'crehana-ui/styles/colors';

import { Container } from 'crehana-ui/GridV2';

const Skeleton = styled.div<{ dark?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props =>
    props.dark ? 'rgba(160,167,203,.32)' : grayLighter};
`;

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 66%;
  z-index: 4;
`;

const Title = styled(Skeleton)<{ dark?: boolean }>`
  position: relative;
  height: 16px;
  background-color: ${props =>
    props.dark ? 'rgba(160,167,203,.2)' : grayLighter};
`;

const DesktopWrapper = styled.div<{ dark?: boolean; isMobile?: boolean }>`
  overflow: hidden;
  position: relative;
  background-color: ${props => {
    if (props.isMobile && props.dark) {
      return '#000';
    }

    if (props.dark) {
      return 'rgba(160,167,203,.2)';
    }

    return '#fff';
  }};
  width: 100%;
`;

const SecondTitleLine = styled(Skeleton)`
  position: relative;
  height: 15px;
  margin-top: 12px;
`;

const CardBody = styled.div`
  width: 100%;
  padding: 24px;
`;

const Price = styled(Skeleton)`
  position: relative;
  width: 40%;
  margin-top: 16px;
  height: 24px;
`;

const Duration = styled(Skeleton)`
  position: relative;
  height: 12px;
  width: 40%;
  margin-top: 20px;
`;

const AddToCart = styled.div<{ dark?: boolean }>`
  position: relative;
  background: white;
  height: 48px;
  background-color: ${props =>
    props.dark ? 'rgba(160,167,203,.2)' : grayMain};
`;

const WrapperMobile = styled.div`
  display: flex;
  flex-direction: row;
  .imageMobile {
    width: 88px;
    height: 88px;
    padding-bottom: 0;
    margin-right: 8px;
  }
  .cardBody {
    width: calc(100% - 88px);
    padding: 0;
  }
`;

interface CardSkeletonPorps {
  className?: string;
  dark?: boolean;
}

export const CourseCardSimpleSkeletion = ({ className }: CardSkeletonPorps) => (
  <DesktopWrapper className={className}>
    <ImageContainer>
      <Skeleton />
    </ImageContainer>
    <CardBody>
      <Title />
      <SecondTitleLine />
      <Duration />
      <Price />
    </CardBody>
  </DesktopWrapper>
);

export const CourseCardSkeleton = ({
  className,
  dark,
  ...rest
}: CardSkeletonPorps) => (
  <DesktopWrapper className={className} dark={dark} {...rest}>
    <ImageContainer>
      <Skeleton dark={dark} />
    </ImageContainer>
    <CardBody>
      <Title dark={dark} />
      <SecondTitleLine dark={dark} />
      <Duration dark={dark} />
      <Price dark={dark} />
      <AddToCart className="mt-24" dark={dark} />
    </CardBody>
  </DesktopWrapper>
);

export const CourseCardSkeletonMobile = ({
  className,
  dark,
  ...rest
}: CardSkeletonPorps) => (
  <div className={`w-full bg-white ${className}`} {...rest}>
    <Container className="relative py-12">
      <WrapperMobile>
        <ImageContainer className="imageMobile">
          <Skeleton dark={dark} />
        </ImageContainer>
        <CardBody className="cardBody">
          <Title dark={dark} />
          <SecondTitleLine dark={dark} />
          <Price dark={dark} />
        </CardBody>
      </WrapperMobile>
      <AddToCart className="mt-16" dark={dark} />
    </Container>
  </div>
);
